import { render, staticRenderFns } from "./Iot.vue?vue&type=template&id=585b3900&scoped=true&"
import script from "./Iot.vue?vue&type=script&lang=js&"
export * from "./Iot.vue?vue&type=script&lang=js&"
import style0 from "./Iot.vue?vue&type=style&index=0&id=585b3900&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585b3900",
  null
  
)

export default component.exports